export {
  wikiGameRegistry,
  getWikiGame,
  listWikiGames,
} from './wiki-games';
import { wikiGameRegistry } from './wiki-games';

export const wikiGame = wikiGameRegistry.arcanatactics;

export const wikiChannels = {
  catalog: { route: 'dcatalog', label: '图鉴', eyebrow: 'GAME COLLECTION' },
  guides: { route: 'dguides', label: '攻略', eyebrow: 'STRATEGY JOURNAL' },
  community: { route: 'dcommunity', label: '社区', eyebrow: 'PLAYER COMMUNITY' },
  tools: { route: 'dtools', label: '工具', eyebrow: 'PLAYER TOOLKIT' },
  benefits: { route: 'dbenefits', label: '福利', eyebrow: 'REDEEM CODES' },
} as const;
export type ChannelKey = keyof typeof wikiChannels;
export const channelByRoute = Object.entries(wikiChannels).reduce((result, [key, value]) => ({ ...result, [value.route]: key as ChannelKey }), {} as Record<string, ChannelKey>);

export const featuredHeroes = [
  { id: '6711', name: '龙骑士', meta: '6 星 · 光辉' }, { id: '5303', name: '德比希', meta: '5 星 · 黑暗' },
  { id: '5807', name: '克罗米', meta: '5 星 · 光辉' }, { id: '4301', name: '诡术师', meta: '4 星 · 黑暗' },
  { id: '3101', name: '符文骑士', meta: '3 星 · 火焰' },
] as const;
export const guides = [
  { id: '684719', category: '竞技场', title: '黄金竞技场攻略', summary: '队伍搭配、站位与战斗思路。', time: '6 分钟' },
  { id: '682872', category: '招募规划', title: '抽卡规划', summary: '角色选择与资源分配的基本原则。', time: '8 分钟' },
  { id: 'guide-001', category: '新手攻略', title: '第一支队伍，应该如何搭建？', summary: '先想清楚每个位置的作用，再决定把资源交给谁。', time: '6 分钟' },
] as const;
export const posts = [
  { id: '719595', tag: '情报', title: '9月特别直播预告，最新活动与奖励情报', author: '社区运营', views: 328 },
  { id: '718927', tag: '讨论', title: '低投入配队思路与资源取舍', author: '林间的冒险家', views: 214 },
  { id: '718611', tag: '创作', title: '本周角色配色与场景截图分享', author: '月下画师', views: 176 },
] as const;
export const tools = [
  ['01', '阵容编辑器', '选择角色、安排站位，保存你的阵容思路。'], ['02', '装备搭配器', '组合装备与套装，比较不同搭配方案。'],
  ['03', '伤害计算器', '根据角色、技能与目标条件预估伤害。'], ['04', '抽卡模拟器', '模拟抽取过程，了解次数与资源消耗。'],
  ['05', '数据统计打分', '按明确的评分规则比较角色与装备。'], ['06', '礼包码兑换器', '整理礼包码，统一查看兑换状态。'],
] as const;
